import { IApplicationState } from 'setup/store'

import { languagesWithIcons } from 'shared/locale'

export const selectLanguage = (state: IApplicationState) => state.userSettings.data.lang
export const selectLanguageChanged = (state: IApplicationState) => state.userSettings.data.isChanged

// export const selectOddType = (state: IApplicationState) => state.userSettings.data.oddType
